export enum BillingPlanType {
  GOOD = 'good',
  BETTER = 'better',
  BEST = 'best',
  STANDARD = 'standard',
  BASIC = 'basic',
  PLUS = 'plus',
  COMPLETE = 'complete',
  PROFESSIONAL = 'professional',
  DIGITAL_VAULT = 'digital_vault'
}
